<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-copyright element-without-heading" id="copyright">
<div class="text" id="copyright-text">
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-563">
<img alt="" class="ornamental-break-image" src="images/break-rule-gradient-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-chapter first-full-width copyright-content">This book is a work of fiction. Any references to historical events, real people, or real locales are used fictitiously. Other names, characters, places, and incidents are the product of the author’s imagination, and any resemblance to actual events or locales or persons, living or dead, is entirely coincidental and not intended by the author.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width copyright-content">Copyright © 2017 by CJ Lyons</p>
<p class="subsq copyright-content">Edgy Reads</p>
<p class="subsq copyright-content">cover design by: George Mayer image courtesy of Adobe Stock</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width copyright-content">All rights reserved.</p>
<p class="subsq copyright-content">No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without written permission from the author, except for the use of brief quotations in a book review.</p>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">CJ Lyons and Thrillers with Heart registered Trademarks of</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">CJ Lyons, LLC</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">Library of Congress Case # 1-4836546081</p>
</div>
</div>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-563">
<img alt="" class="ornamental-break-image" src="images/break-rule-gradient-screen.png"/>
</div>
</div>
</div>
<p class="created-with-vellum"><a href="http://tryvellum.com/created" target="_blank"><span class="created-with-vellum-image-decorator"><span class="created-with-vellum-image-size-container"><img alt="Vellum flower icon" class="created-with-vellum-image" src="images/vellum-created.png"/></span></span> <span class="created-with-vellum-text">Created with Vellum</span></a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?a7e56b7a